<!-- The dialog never closes itself; escape, backdrop and the close icon come back
     as `dmModalCloseClick` and are answered here. -->
<dm-modal
  size="sm"
  [open]="isModalOpen()"
  [label]="title"
  [canautoclose]="false"
  [withclickoutside]="false"
  (dmModalCloseClick)="close()"
  [lpOverlayDismissGuard]="isModalOpen()"
  (lpOverlayDismissed)="close()"
>
  <dm-modal-header slot="header" align="start" [stacked]="false" [bordered]="true" [heading]="title" [description]="description">
    <dm-icon slot="icon" [featured]="true" theme="modern" color="gray" size="lg" name="life-buoy-01" />
  </dm-modal-header>

  <form [formRoot]="messageForm" class="lp-kontakt-modal__body dm-flex dm-flex-column dm-gap-24">
    @if (projektleiter(); as projektleiter) {
      <div class="dm-flex dm-flex-column dm-gap-8">
        <dm-label>{{ contactLabel }}</dm-label>
        <dm-avatar size="md" [imgsrc]="contactImageUrl()" [lpAvatarFromPerson]="contactPerson()">
          <span slot="title">{{ contactName() }}</span>
          <span slot="subtitle"
            >{{ projektleitungLabel }}
            @if (projektleiter.email) {
              · {{ projektleiter.email }}
            }
          </span>
        </dm-avatar>
      </div>
    }

    <dm-input
      type="textarea"
      inputId="kontakt-message"
      dmSize="sm"
      [label]="messageLabel()"
      [rows]="5"
      [placeholder]="messagePlaceholder"
      [hint]="responseHint"
      [errormsg]="messageErrorMessage()"
      [formField]="messageForm.message"
    />
  </form>

  <dm-modal-footer slot="footer" [bordered]="true">
    <dm-button color="secondary" dmType="button" (click)="close()">{{ closeLabel }}</dm-button>
    <dm-button
      color="primary"
      dmType="button"
      [isLoading]="isSending()"
      [showTextWhileLoading]="true"
      [disabled]="!canSend()"
      (click)="send()"
      >{{ sendLabel }}</dm-button
    >
  </dm-modal-footer>
</dm-modal>
